import { render } from "./GenerateQCMModal.vue?vue&type=template&id=0b8acd8b&scoped=true"
import script from "./GenerateQCMModal.vue?vue&type=script&lang=js"
export * from "./GenerateQCMModal.vue?vue&type=script&lang=js"

import "./GenerateQCMModal.vue?vue&type=style&index=0&id=0b8acd8b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8acd8b"]])

export default __exports__